const credentialsKey = "credentials";
export class CredentialsStore {
    _credentials = null;
    constructor() {
        const savedCredentials = sessionStorage.getItem(credentialsKey) ||
            localStorage.getItem(credentialsKey);
        if (savedCredentials) {
            this._credentials = JSON.parse(savedCredentials);
        }
    }
    isAuthenticated() {
        return !!this.credentials;
    }
    get credentials() {
        return this._credentials;
    }
    setCredentials(credentials, remember) {
        this._credentials = credentials || null;
        if (credentials) {
            const storage = remember ? localStorage : sessionStorage;
            storage.setItem(credentialsKey, JSON.stringify(credentials));
        }
        else {
            sessionStorage.removeItem(credentialsKey);
            localStorage.removeItem(credentialsKey);
        }
    }
}
